import { ProfilePageTranslations } from "./types";

export const deTranslations: ProfilePageTranslations = {
    goBack: "Zurück",
    heading: "Profil",
    email: "E-Mail",
    user: "Benutzer",
    dfn: "DFN",
    institution: "Institution",
    role: "Rolle",
    dateCreated: "Erstellungsdatum",
    gamesPlayed: "Anzahl gespielter Sessions",
    patientsSeen: "Anzahl behandelter virtueller Patient:innen",
    currentLicense: "Aktuelle Nutzungs-Lizenz",
    licenseExpiryDate: "Lizenz-Ablaufdatum",
    changePassword: "Passwort ändern",
    seeBadges: "Abzeichen anzeigen",
    seeClasses: "Session anzeigen"
};
